export default "__VITE_ASSET__CQlpL9o4__"